import BaseModel from './base.model';

export default class AuditLog extends BaseModel {
}
